import http from "../../axios-config/g-http-metodos";

function getProduto(){
    const{res, erro, requisicao} = http.get('Produto/Get')
    return{ ProdutoArray: res, erro , requisicao}
}

function GetRotaImagemProdutoByProdutoId(produtoId){
    const { res, erro, requisicao } = http.get(`Produto/GetRotaImagemProdutoByProdutoId/${produtoId}`)
    return { res , erro, requisicao }
  }
  

function getProdutoByOrcamentoId(orcamentoId){
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoByOrcamentoId/${orcamentoId}`)
    return{ ProdutoId : res , erro, requisicao}
}

function getProdutoByUsuarioId(filtroNome, orcamentoId){// retorna produtos referencia do representante/usuario
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoByUsuarioId/${filtroNome}/${orcamentoId}`)
    return{ ProdutoArray: res, erro , requisicao}
}

function GetProdutoByUsuarioIdEmpresaId(filtroNome, orcamentoId, EmpresaId){// retorna produtos referencia do representante/usuario
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoByUsuarioIdEmpresaId/${filtroNome}/${orcamentoId}/${EmpresaId}`)
    return{ ProdutoArray: res, erro , requisicao}
}
function GetProdutosAtivos(){
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoAtivos`)
    return{ ProdutoArray : res , erro, requisicao}
}

function getOrcamentoProdutoLiberados(filtroNome, clienteId){
    const{res, erro, requisicao} = http.get(`OrcamentoProdutoLiberado/Get/${filtroNome}/${clienteId}`)
    return{ OrcamentoProdutoArray: res, erro , requisicao}
}

function getProdutoByClienteIdOrcamento(orcamentoId){
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoByClienteIdOrcamento/${orcamentoId}`)
    return{ ProdutoArray : res , erro, requisicao}
}
function GetSistemaByFiltro(componenteTipo,filtroNome){
    const{res, erro, requisicao} = http.get(`GetSistemaByFiltro/${componenteTipo}/${filtroNome}`)
    return{ SistemaArray: res, erro , requisicao}
}

function getProdutoDropDown(orcamentoId, empresa, cliente, representante, pesquisa , empresaId = null) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutosByClienteOrcamento/${orcamentoId}/${empresa}/${cliente}/${representante}/${pesquisa}/${empresaId}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoDropDownPedidoCaracteristica(empresa, cliente, representante, pesquisa , empresaId = null, clienteId) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoDropDownPedidoCaracteristica/${empresa}/${cliente}/${representante}/${pesquisa}/${empresaId}/${clienteId}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoDropDownByPesquisaRepresentanteEmpresa(pesquisa, representanteId, empresaId = null) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoDropDownByPesquisaRepresentanteEmpresa/${pesquisa}/${representanteId}${empresaId ? '/' + empresaId : ''}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoByPesquisaEmpresa(pesquisa, empresaId) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoByPesquisaEmpresa/${pesquisa}/${empresaId}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoNovoByPesquisaEmpresa(pesquisa, empresaId) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoNovoByPesquisaEmpresa/${pesquisa}/${empresaId}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoNovoByPesquisaRepresentante(pesquisa, representanteId, empresaId = null) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoNovoByPesquisaRepresentante/${pesquisa}/${representanteId}${empresaId ? '/' + empresaId : ''}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoNovoByPesquisa(pesquisa, empresaId= null) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoNovoByPesquisa/${pesquisa}${empresaId ? '/' + empresaId : ''}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoByOrcamentoClienteEmpresa(orcamentoId) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoByOrcamentoClienteEmpresa/${orcamentoId}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetCodigoByProdutoId(produtoId){
    const{res, erro, requisicao} = http.get(`Produto/GetCodigoByProdutoId/${produtoId}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoByPesquisa(pesquisa, empresaId) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoByPesquisa/${pesquisa}${empresaId ? '/' + empresaId : ''}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoByPesquisaRepresentante(pesquisa, empresaId, representanteId, clienteId) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoByPesquisaRepresentante/${pesquisa}${empresaId ? '/' + empresaId : ''}${representanteId ? '/' + representanteId : ''}${clienteId ? '/' + clienteId : ''}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoByTableSistema() {
    const{res, erro, requisicao} = http.get(`/GetProdutoByTableSistema`)
    return{ ProdutoOpcoesProdutoNumero : res , erro, requisicao}
}

function GetPorId(produtoid) {
    const{res, erro, requisicao} = http.get(`Produto/GetPorId/${produtoid}`)
    return{ ProdutoArray : res , erro, requisicao}
}

function GetProdutoByClienteEmpresaRepresentante(clienteId, empresaId, representanteId) {
    const{res, erro, requisicao} = http.get(`Produto/GetProdutoByClienteEmpresaRepresentante/${clienteId}/${empresaId}/${representanteId}`)
    return{ ProdutoArray : res , erro, requisicao}
}






const ProdutoController ={
    getProduto,
    getProdutoDropDown,
    GetProdutoByTableSistema,
    getProdutoByOrcamentoId,
    getProdutoByUsuarioId,
    GetProdutosAtivos,
    getOrcamentoProdutoLiberados,
    getProdutoByClienteIdOrcamento,
    GetSistemaByFiltro,
    GetProdutoByUsuarioIdEmpresaId,
    GetProdutoByOrcamentoClienteEmpresa,
    GetProdutoDropDownByPesquisaRepresentanteEmpresa,
    GetProdutoByPesquisaEmpresa,
    GetProdutoNovoByPesquisaEmpresa,
    GetCodigoByProdutoId,
    GetProdutoDropDownPedidoCaracteristica,
    GetProdutoNovoByPesquisaRepresentante,
    GetProdutoNovoByPesquisa,
    GetProdutoByPesquisa,
    GetPorId,
    GetProdutoByClienteEmpresaRepresentante,
    GetProdutoByPesquisaRepresentante,
    GetRotaImagemProdutoByProdutoId
        
}

export default ProdutoController